import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, OnInit } from '@angular/core';
import { CostPriceFormat } from '~/models/administration/costPriceFormat';
import { DateFormat } from '~/models/administration/dateFormat';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class FormatService extends ApiServiceBase implements OnInit {

  dateFormat: string;
  costFormat: string;
  costFormatValue: string;

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.settings);
  }
  ngOnInit(): void {

  }

  getDateFormat() {
    return this.http.get<DateFormat[]>(this._url(`/date-format`));
  }

  getCostPriceFormat() {
    return this.http.get<CostPriceFormat[]>(this._url(`/cost-price-format`));
  }

  updateDateFormat(model: any) {
    return this.client.put(this._url(`/date-format`), model);
  }

  updateCostPriceFormat(model: any) {
    return this.client.put(this._url(`/cost-price-format`), model);
  }

  getFormats() {
    this.http.get<DateFormat[]>(this._url(`/date-format`)).subscribe((x: DateFormat[]) => {
      this.dateFormat = x.find((x) => x.enabled).value
    });

    this.http.get<CostPriceFormat[]>(this._url(`/cost-price-format`)).subscribe((x: CostPriceFormat[]) => {
      this.costFormat = x.find((x) => x.enabled)?.value;

      if (x.find((x) => x.enabled)?.key === '2') this.costFormatValue = 'n2';
      else if (x.find((x) => x.enabled)?.key === '3') this.costFormatValue = 'n3';
      else if (x.find((x) => x.enabled)?.key === '4') this.costFormatValue = 'n4';
    });
  }

  async getDigitNumber(format: string) {
    var splitedFormat: string[] = format.split('n');
    var digitNumber: number = +splitedFormat[1];

    return digitNumber;
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Format${v}`);
  }
}
